//console.log("TESTJS")

//console.log(window.is_wcp_wholesale_customer_octo)
//console.log(wcp_customer_octo)
if (window.is_wcp_wholesale_customer_octo == true) {

  // saved product page data;
  window.wpdExtensionProductPageData = undefined;

  // if page is product and no save data is found
  if (window.wpdExtensionIsProductPage != "" && window.wpdExtensionProductPageData == undefined && window.wpdExtensionIsProductPage.variants.length > 1) {
    let wpdPayloadItem = [];
    window.wpdExtensionIsProductPage.variants.forEach(variant => {
      wpdPayloadItem.push({
        "variant_id": variant.id.toString(),
        "product_id": window.wpdExtensionIsProductPage.id.toString(),
        "compare_at_price": variant.compare_at_price == null ? "" : variant.compare_at_price.toString(),
        "price": variant.price.toString(),
        "quantity": 1,
        "send_vd_table": true,
        "handle": window.wpdExtensionIsProductPage.handle,
        "collection_ids": window.wpdExtensionProductCollectionIds
      })
    });

    let wpdRequestAPIPayload = {
      "admin_domain": window.shopPermanentDomain,
      "customer_tags": window.wcp_customer_octo.tags,
      "items": wpdPayloadItem,
      "market_currency": window.Shopify.currency.active,
      "market_currency_exchange_rate": window.Shopify.currency.rate,
      "market_country": window.Shopify.country
    }

    fetch(window.wpdAPIRootUrl + "cost-tree/prices-retrieval/", {
      method: "POST",
      credentials: "same-origin",
      headers: new Headers({ "Content-Type": "application/json", "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJ3cGRfYXBpIiwiaXNzI" }),
      body: JSON.stringify(wpdRequestAPIPayload)
    }).then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          // saved data for product page
          window.wpdExtensionProductPageData = data;
          let wpdPriceElements = document.querySelectorAll("[data-wpd-product-handle='" + window.wpdExtensionIsProductPage.handle + "']");
          findAndReplace(data, wpdPriceElements);
        });
      } else {
        console.log("Error in WPD integration");
      }
    }).catch((error) => {
      console.log("wpd integration error", error);
    });
  }

  // replace price on page load 
  let wpdPriceElements = document.querySelectorAll("[data-wpd-product-handle]:not(.wpd-processed)");
  if (wpdPriceElements.length != 0) {
    replaceWPDPrice(wpdPriceElements);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      wpdPriceElements = document.querySelectorAll("[data-wpd-product-handle]:not(.wpd-processed)");
      if (wpdPriceElements.length != 0) {
        replaceWPDPrice(wpdPriceElements);
      }
    });
  }

  if (!window.wpdExtensionIsCartPage) {
    let wpdCartPriceElements = document.querySelectorAll("[data-wpd-cart-drawer-item]:not(.wpd-processed)");
    if (wpdCartPriceElements.length > 0) {
      replaceWPDCartPrice(wpdCartPriceElements);
    }
  }

  // replace price for elements which are added dynamically
  const observerSearch = new MutationObserver((mutations) => {

    wpdPriceElements = document.querySelectorAll("[data-wpd-product-handle]:not(.wpd-processed)");
    if (wpdPriceElements.length > 0) {
      replaceWPDPrice(wpdPriceElements);
    }

    if (!window.wpdExtensionIsCartPage) {
      let wpdCartPriceElements = document.querySelectorAll("[data-wpd-cart-drawer-item]:not(.wpd-processed)");
      if (wpdCartPriceElements.length > 0) {
        replaceWPDCartPrice(wpdCartPriceElements);
      }
    }
  });

  let wpdBodyInterval = setInterval(function () {
    if (document.querySelector("body") != null) {
      clearInterval(wpdBodyInterval);
      observerSearch.observe(document.querySelector("body"), {
        subtree: true,
        childList: true,
      });
    }
  }, 250);

  // replace normal page prices
  function replaceWPDPrice(wpdPriceElements) {

    // create payload
    let handles = [];
    let handle = "";
    let wpdPayloadItem = [];
    let stringHandles = "";
    for (let i = 0; i < wpdPriceElements.length; i++) {
      handle = wpdPriceElements[i].getAttribute("data-wpd-product-handle");
      wpdPriceElements[i].classList.add("wpd-processed");
      if (handle != undefined && handle != null && wpdPriceElements[i].getAttribute("data-wpd-variant-id") != null && wpdPriceElements[i].getAttribute("data-wpd-variant-id").trim() != "" && handles.indexOf(handle + wpdPriceElements[i].getAttribute("data-wpd-variant-id").trim()) == -1) {
        handles.push(handle + wpdPriceElements[i].getAttribute("data-wpd-variant-id").trim());

        // if page is product and save data is found
        if (window.wpdExtensionIsProductPage.handle == handle && window.wpdExtensionProductPageData != undefined) {
          findAndReplace(window.wpdExtensionProductPageData, wpdPriceElements);
        }
        // for other elements and for other pages
        else {

          if (wpdPriceElements[i].getAttribute("data-wpd-product-id") == null || wpdPriceElements[i].getAttribute("data-wpd-product-collection-ids") == null) {
            stringHandles += handle + ",";
          } else {
            wpdPayloadItem.push({
              "variant_id": wpdPriceElements[i].getAttribute("data-wpd-variant-id"),
              "product_id": wpdPriceElements[i].getAttribute("data-wpd-product-id"),
              "compare_at_price": wpdPriceElements[i].getAttribute("data-wpd-variant-compare-at-price"),
              "price": wpdPriceElements[i].getAttribute("data-wpd-variant-price"),
              "quantity": 1,
              "send_vd_table": window.wpdExtensionIsProductPage.handle == handle ? true : false,
              "handle": handle,
              "collection_ids": wpdPriceElements[i].getAttribute("data-wpd-product-collection-ids")
            })
          }
        }
      } else {
        wpdPriceElements[i].style.visibility = "visible";
      }
    }
    stringHandles = stringHandles.replace(/,\s*$/, "");
    //console.log(wpdPayloadItem);
    if (stringHandles != "") {
      let wpdRequestAPIPayload = {
        "admin_domain": window.shopPermanentDomain,
        "customer_tags": window.wcp_customer_octo.tags,
        "handles": stringHandles,
        "buyers_country": window.Shopify.country,
        "specific_product_handle_query": true,
        "market_currency": window.Shopify.currency.active,
        "market_currency_exchange_rate": window.Shopify.currency.rate,
        "market_country": window.Shopify.country
      }
      fetch(window.wpdAPIRootUrl + "cost-tree/shopify-products-prices-retrieval/", {
        method: "POST",
        credentials: "same-origin",
        headers: new Headers({ "Content-Type": "application/json", "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJ3cGRfYXBpIiwiaXNzI" }),
        body: JSON.stringify(wpdRequestAPIPayload)
      }).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            //console.log(data);
            // replacement logic
            findAndReplace(data, wpdPriceElements, true);
          });
        } else {
          console.log("Error in WPD integration");
          if (document.getElementById("wpdDiscountCss") != null) { document.getElementById("wpdDiscountCss").remove(); }
          observerSearch.disconnect();
        }
      }).catch((error) => {
        // if api throws error terminate the process and shutdown observer
        observerSearch.disconnect();
        if (document.getElementById("wpdDiscountCss") != null) { document.getElementById("wpdDiscountCss").remove(); }
        console.log("wpd integration error", error);
      });
    }

    if (wpdPayloadItem.length > 0) {
      let wpdRequestAPIPayload = {
        "admin_domain": window.shopPermanentDomain,
        "customer_tags": window.wcp_customer_octo.tags,
        "items": wpdPayloadItem,
        "market_currency": window.Shopify.currency.active,
        "market_currency_exchange_rate": window.Shopify.currency.rate,
        "market_country": window.Shopify.country
      }
      fetch(window.wpdAPIRootUrl + "cost-tree/prices-retrieval/", {
        method: "POST",
        credentials: "same-origin",
        headers: new Headers({ "Content-Type": "application/json", "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJ3cGRfYXBpIiwiaXNzI" }),
        body: JSON.stringify(wpdRequestAPIPayload)
      }).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            //console.log(data);
            // replacement logic
            findAndReplace(data, wpdPriceElements);

          });
        } else {
          console.log("Error in WPD integration");
          if (document.getElementById("wpdDiscountCss") != null) { document.getElementById("wpdDiscountCss").remove(); }
          observerSearch.disconnect();
        }
      }).catch((error) => {
        // if api throws error terminate the process and shutdown observer
        observerSearch.disconnect();
        if (document.getElementById("wpdDiscountCss") != null) { document.getElementById("wpdDiscountCss").remove(); }
        console.log("wpd integration error", error);
      });
    }
  }

  function findAndReplace(data, wpdPriceElements, isDataByHandle = false) {
    let dataItem;
    for (let i = 0; i < wpdPriceElements.length; i++) {
      dataItem = data[wpdPriceElements[i].getAttribute("data-wpd-variant-id")];
      if (dataItem != undefined && wpdPriceElements[i].getAttribute("data-wpd-variant-id") == dataItem.variant_id) {
        if (window.wpdExtensionIsProductPage != "" && window.wpdExtensionIsProductPage.id == dataItem.product_id && document.getElementById("wcp_vd_table") != null && dataItem.applicable_volume_discounts != null && dataItem.applicable_volume_discounts != "") {
          createVdHtml(dataItem.applicable_volume_discounts, dataItem.vd_table_helper_text, { "tax_rule": data.tax_rule });
        } else if (window.wpdExtensionIsProductPage != "" && window.wpdExtensionIsProductPage.id == dataItem.product_id && document.getElementById("wcp_vd_table") != null && isDataByHandle == false) {
          document.getElementById("wcp_vd_table").innerHTML = "";
        }
        addPriceHtml(wpdPriceElements[i], dataItem.wpd_v_price, dataItem.wpd_v_compare_at_price, { "wpd_v_tax_incl_price": dataItem.wpd_v_tax_incl_price, "wpd_v_tax_excl_price": dataItem.wpd_v_tax_excl_price, "tax_rule": data.tax_rule });
      }
      wpdPriceElements[i].style.visibility = "visible";
    }
  }

  // replace html of price element 
  function addPriceHtml(element, price, compareAtPrice, taxIncExclData) {
    let priceHtml = wpdFormatePrice(price);

    if ((taxIncExclData.wpd_v_tax_incl_price != undefined || taxIncExclData.wpd_v_tax_excl_price != undefined) && taxIncExclData.tax_rule != undefined) {
      // check which price need to show first
      if ((taxIncExclData.tax_rule.price_in_highlight_setting == "tax_excluded_price" || taxIncExclData.tax_rule.price_display_setting == "single_price") && taxIncExclData.wpd_v_tax_excl_price != undefined && !isNaN(taxIncExclData.wpd_v_tax_excl_price)) {
        priceHtml = "<span class='wpd-tax-excl-price'>" + wpdFormatePrice(taxIncExclData.wpd_v_tax_excl_price) + " " + taxIncExclData.tax_rule.label_of_tax_excluded_price + "</span>";
        // whether we have to show inclusive price or not
        if (taxIncExclData.wpd_v_tax_incl_price != undefined && !isNaN(taxIncExclData.wpd_v_tax_incl_price)) {
          priceHtml += "<br class='wpd-tax-excl-price-br'/><small class='wpd-tax-incl-price'>(" + wpdFormatePrice(taxIncExclData.wpd_v_tax_incl_price) + " " + taxIncExclData.tax_rule.label_of_tax_included_price + ")</small>";
        }
      } else if ((taxIncExclData.tax_rule.price_in_highlight_setting == "tax_included_price" || taxIncExclData.tax_rule.price_display_setting == "single_price") && taxIncExclData.wpd_v_tax_incl_price != undefined && !isNaN(taxIncExclData.wpd_v_tax_incl_price)) {
        priceHtml = "<span class='wpd-tax-incl-price'>" + wpdFormatePrice(taxIncExclData.wpd_v_tax_incl_price) + " " + taxIncExclData.tax_rule.label_of_tax_included_price + "</span>";
        // whether we have to show exclusive price or not
        if (taxIncExclData.wpd_v_tax_excl_price != undefined && !isNaN(taxIncExclData.wpd_v_tax_excl_price)) {
          priceHtml += "<br class='wpd-tax-excl-price-br'/><small class='wpd-tax-excl-price'>(" + wpdFormatePrice(taxIncExclData.wpd_v_tax_excl_price) + " " + taxIncExclData.tax_rule.label_of_tax_excluded_price + ")</small>";
        }
      }
    }

    if (window.showCrossOutPrice && compareAtPrice != null && compareAtPrice != 0 && price != compareAtPrice) {
      priceHtml = "<s class='wpd-ext-compare-at-price'>" + wpdFormatePrice(compareAtPrice) + "</s>" + priceHtml;
    }
    element.innerHTML = priceHtml;
  }

  // create formatted html of price
  function wpdFormatePrice(price) {
    return window.WPDMoneyFormat.replace(/({{\s*amount\s*}})/g, (price / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
      .replace(/({{\s*amount_no_decimals\s*}})/g, Math.ceil(price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
      .replace(/({{\s*amount_with_comma_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
      .replace(/({{\s*amount_no_decimals_with_comma_separator\s*}})/g, Math.ceil(price / 100).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
      .replace(/({{\s*amount_with_apostrophe_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
      .replace(/({{\s*amount_no_decimals_with_space_separator\s*}})/g, Math.ceil(price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))
      .replace(/({{\s*amount_with_space_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, " "))
      .replace(/({{\s*amount_with_period_and_space_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ".").replace(/\B(?=(\d{3})+(?!\d))/g, " "));
       
  }

  // get query string value
  function wpdQuerystring(name) {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // create VD table
  function createVdHtml(data, vd_table_helper_text, taxIncExclData) {
    let wholeVariantVdData = data;
    let vdHTML = "<table><tr><th>Quantity</th><th>Discount</th><th>Price</th></tr>";
    let priceElement = document.createElement("span");
    for (let index = 0; index < wholeVariantVdData.length; index++) {
      const element = wholeVariantVdData[index];
      priceElement = document.createElement("span");
      addPriceHtml(priceElement, element.price, 0, { "wpd_v_tax_incl_price": element.tax_included_price, "wpd_v_tax_excl_price": element.tax_excluded_price, "tax_rule": taxIncExclData.tax_rule });
      vdHTML += "<tr><td>" + element.quantity + "</td><td>" + element.extra_discount + "</td><td>" + priceElement.innerHTML + "</td></tr>";
    }
    vdHTML += "</table>";
    document.getElementById("wcp_vd_table").innerHTML = "<b><span>" + vd_table_helper_text + "</span></b><br>" + vdHTML;
  }


  // replace cart drawer price
  function replaceWPDCartPrice(wpdCartPriceElements) {
    // create request payload
    let handle = "";
    let wpdPayloadItem = [];
    let stringHandles = "";
    let useHandleMethod = false;
    for (let i = 0; i < wpdCartPriceElements.length; i++) {
      handle = wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-product-handle");
      wpdCartPriceElements[i].classList.add("wpd-processed");
      if (wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-line-price") != null && handle != undefined && handle != null) {
        if (useHandleMethod == true || wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-product-collection-ids") == null) {
          stringHandles += handle + ",";
          useHandleMethod = true;
          wpdPayloadItem.push({
            "handle": handle,
            "variant_id": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-variant-id"),
            "product_id": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-product-id"),
            "quantity": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-quantity")
          })
        } else {
          wpdPayloadItem.push({
            "variant_id": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-variant-id"),
            "product_id": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-product-id"),
            "compare_at_price": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-variant-compare-at-price"),
            "price": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-variant-price"),
            "quantity": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-quantity"),
            "handle": handle,
            "collection_ids": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-product-collection-ids"),
            "key": wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-item")
          })
        }
      }
    }

    let wpdRequestAPIPayload = {
      "admin_domain": window.shopPermanentDomain,
      "customer_tags": window.wcp_customer_octo.tags,
      "is_cart_page": true,
      "market_currency": window.Shopify.currency.active,
      "market_currency_exchange_rate": window.Shopify.currency.rate,
      "market_country": window.Shopify.country
    };
    let url = window.wpdAPIRootUrl + "cost-tree/prices-retrieval/";

    if (stringHandles != "") {
      wpdRequestAPIPayload.handles = stringHandles;
      wpdRequestAPIPayload.buyers_country = window.Shopify.country;
      wpdRequestAPIPayload.cart_items = wpdPayloadItem;
      wpdRequestAPIPayload.specific_product_handle_query = true;
      url = window.wpdAPIRootUrl + "cost-tree/shopify-products-prices-retrieval/";
    }
    if (!useHandleMethod) {
      wpdRequestAPIPayload.items = wpdPayloadItem;
    }

    //console.log(wpdPayloadItem);
    if (wpdPayloadItem.length > 0 || stringHandles != "") {

      fetch(url, {
        method: "POST",
        credentials: "same-origin",
        headers: new Headers({ "Content-Type": "application/json", "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJ3cGRfYXBpIiwiaXNzI" }),
        body: JSON.stringify(wpdRequestAPIPayload)
      }).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            let wpdCartTotal = 0, originalCartTotal = 0, wpdCartTotalUsingUniqueElement = 0, originalCartTotalUsingUniqueElement = 0;
            let cartTotalElements = [];
            let wpdCartDrawerUniqueElements = {};
            let cartKey = "";
            let lineTaxInclPrice,lineTaxExclPrice;
            //console.log(data);
            // replace price elements html
            for (let i = 0; i < wpdCartPriceElements.length; i++) {
              dataItem = data[wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-variant-id")];
              if (dataItem != undefined) {
                if (wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-line-price") == null) {
                  addPriceHtml(wpdCartPriceElements[i], dataItem.wpd_v_price, dataItem.wpd_v_compare_at_price, { "wpd_v_tax_incl_price": dataItem.wpd_v_tax_incl_price, "wpd_v_tax_excl_price": dataItem.wpd_v_tax_excl_price, "tax_rule": data.tax_rule });
                  if (dataItem.vd != null) {
                    wpdCartPriceElements[i].insertAdjacentHTML('beforeend', "<br/>" + dataItem.VDNextDiscountHtml);
                  }
                } else {
                  wpdCartTotal = wpdCartTotal + (((dataItem.wpd_v_price / 100).toFixed(2)) * parseInt(dataItem.quantity));
                  originalCartTotal = originalCartTotal + parseInt(dataItem.original_price) * parseInt(dataItem.quantity);
                  lineTaxInclPrice = dataItem.wpd_v_tax_incl_price * dataItem.quantity;
                  lineTaxExclPrice = dataItem.wpd_v_tax_excl_price * dataItem.quantity;
                  if(dataItem.wpd_v_tax_incl_price == null){
                    lineTaxInclPrice = undefined;
                  }
                  if(dataItem.wpd_v_tax_excl_price == null){
                    lineTaxExclPrice = undefined;
                  }
                  addPriceHtml(wpdCartPriceElements[i], dataItem.wpd_v_price * dataItem.quantity, dataItem.wpd_v_compare_at_price * dataItem.quantity, { "wpd_v_tax_incl_price": lineTaxInclPrice, "wpd_v_tax_excl_price": lineTaxExclPrice, "tax_rule": data.tax_rule });
                }

                cartKey = wpdCartPriceElements[i].getAttribute("data-wpd-cart-drawer-item");
                if (cartKey != null && cartKey != "" && wpdCartDrawerUniqueElements[cartKey] == undefined) {
                  wpdCartDrawerUniqueElements[cartKey] = true;
                  wpdCartTotalUsingUniqueElement = wpdCartTotalUsingUniqueElement + (((dataItem.wpd_v_price / 100).toFixed(2)) * parseInt(dataItem.quantity));
                  originalCartTotalUsingUniqueElement = originalCartTotalUsingUniqueElement + parseInt(dataItem.original_price) * parseInt(dataItem.quantity);
                }
              }
              wpdCartPriceElements[i].style.visibility = "visible";
            }

            // handle cart total replacement
            cartTotalElements = document.querySelectorAll("[data-wpd-cart-total]");
            if (cartTotalElements.length > 0) {
              if (wpdCartTotalUsingUniqueElement != 0) {
                wpdCartTotal = wpdCartTotalUsingUniqueElement;
                originalCartTotal = originalCartTotalUsingUniqueElement;
              }
              wpdCartTotal = wpdCartTotal * 100;
              if (window.showCrossOutPrice && originalCartTotal != wpdCartTotal) {
                cartTotalElements.forEach(element => {
                  element.innerHTML = "<s class='wpd-ext-compare-at-price'>" + wpdFormatePrice(originalCartTotal) + "</s>" + wpdFormatePrice(wpdCartTotal);
                });
              } else {
                cartTotalElements.forEach(element => { element.innerHTML = wpdFormatePrice(wpdCartTotal); });
              }
            }
          });
        }
      }).catch((error) => {
        if (document.getElementById("wpdDiscountCss") != null) { document.getElementById("wpdDiscountCss").remove(); }
        console.log("wpd integration error", error);
      });
    }
  }

  // bind cart drawer checkout buttons event to prevent default checkout
  if (!window.wpdExtensionIsCartPage) {
    let checkoutBtnInterval = setInterval(function () {
      let checkoutElements = document.querySelectorAll("input[name='checkout'], button[name='checkout'], input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'], [href$='checkout']");
      for (var i = 0; i < checkoutElements.length; i++) {
        checkoutElements[i].addEventListener('click', function (event) {
          event.stopPropagation();
          event.preventDefault();
          window.location = '/cart';
        }, false);
      }
      if (checkoutElements.length > 1) {
        clearInterval(checkoutBtnInterval);
      }
    }, 500)
    document.cookie = 'wpd_market_address_refreshed=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}